import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StyledAppointmentContent = styled('div')(
  ({ theme }) => `
     background-color: ${theme.DS_palette.background.light};
     padding: ${theme.DS_spacing(['xs'])};
     border-radius: ${theme.DS_border.radius.priceCard};
    `,
);
export const StyledQuestion = styled(Typography)(
  ({ theme }) => `
      margin-top: ${theme.DS_spacing(['xs'])};
    `,
);

export const StyledLink = styled('a')(
  () => `
       white-space: nowrap;
       &:hover {
        cursor: pointer;
       }
    `,
);
